var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "36px",
    viewBox: "0 0 27 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-pdf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000104606113 34.6534653 26.8245988 34.6534653 26.8245988 0.0853168317 0.000104606113 0.0853168317"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Parth",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-pdf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped",
    transform: "translate(0.000000, 0.261218)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1432643,8.14848515 L21.7968803,8.14848515 L19.3721106,8.14848515 C18.9958773,8.14848515 18.6907762,7.8459604 18.6907762,7.47308911 L18.6907762,0.760712871 C18.6907762,0.758633663 18.6907762,0.75690099 18.6907762,0.754821782 L18.6907762,0.0853168317 L0.681439087,0.0853168317 C0.305205768,0.0853168317 0.000104606113,0.387841584 0.000104606113,0.760712871 L0.000104606113,33.9777921 C0.000104606113,34.3510099 0.305205768,34.6535347 0.681439087,34.6535347 L26.1432643,34.6535347 C26.5194976,34.6535347 26.8245988,34.3510099 26.8245988,33.9777921 L26.8245988,8.14848515 L26.1432643,8.14848515 Z",
    id: "Fill-1",
    fill: "#DC2B2B",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#8F1B1B",
    fillRule: "nonzero",
    points: "20.0535497 0.742242574 20.0535497 7.05887624 26.4254567 7.05887624"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PDF",
    transform: "translate(6.000000, 23.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.59,6 L1.59,4.09125 L2.3475,4.09125 C2.7,4.09125 3.0075,4.0475 3.27,3.96 C3.5325,3.8725 3.75125,3.75 3.92625,3.5925 C4.10125,3.435 4.2325,3.246875 4.32,3.028125 C4.4075,2.809375 4.45125,2.56875 4.45125,2.30625 C4.45125,2.05375 4.41,1.82125 4.3275,1.60875 C4.245,1.39625 4.1175,1.21375 3.945,1.06125 C3.7725,0.90875 3.55375,0.79 3.28875,0.705 C3.02375,0.62 2.71,0.5775 2.3475,0.5775 L2.3475,0.5775 L0.58125,0.5775 L0.58125,6 L1.59,6 Z M2.3475,3.30375 L1.59,3.30375 L1.59,1.3575 L2.3475,1.3575 C2.5325,1.3575 2.69375,1.379375 2.83125,1.423125 C2.96875,1.466875 3.0825,1.53 3.1725,1.6125 C3.2625,1.695 3.33,1.795 3.375,1.9125 C3.42,2.03 3.4425,2.16125 3.4425,2.30625 C3.4425,2.45875 3.42,2.596875 3.375,2.720625 C3.33,2.844375 3.2625,2.949375 3.1725,3.035625 C3.0825,3.121875 2.96875,3.188125 2.83125,3.234375 C2.69375,3.280625 2.5325,3.30375 2.3475,3.30375 L2.3475,3.30375 Z M7.305,6 C7.715,6 8.08875,5.93375 8.42625,5.80125 C8.76375,5.66875 9.0525,5.4825 9.2925,5.2425 C9.5325,5.0025 9.71875,4.71625 9.85125,4.38375 C9.98375,4.05125 10.05,3.68625 10.05,3.28875 C10.05,2.89125 9.98375,2.52625 9.85125,2.19375 C9.71875,1.86125 9.5325,1.575625 9.2925,1.336875 C9.0525,1.098125 8.76375,0.911875 8.42625,0.778125 C8.08875,0.644375 7.715,0.5775 7.305,0.5775 L7.305,0.5775 L5.235,0.5775 L5.235,6 L7.305,6 Z M7.305,5.1975 L6.25125,5.1975 L6.25125,1.38 L7.305,1.38 C7.57,1.38 7.808125,1.42375 8.019375,1.51125 C8.230625,1.59875 8.41,1.724375 8.5575,1.888125 C8.705,2.051875 8.81875,2.251875 8.89875,2.488125 C8.97875,2.724375 9.01875,2.99125 9.01875,3.28875 C9.01875,3.58625 8.97875,3.853125 8.89875,4.089375 C8.81875,4.325625 8.705,4.525625 8.5575,4.689375 C8.41,4.853125 8.230625,4.97875 8.019375,5.06625 C7.808125,5.15375 7.57,5.1975 7.305,5.1975 L7.305,5.1975 Z M11.8575,6 L11.8575,3.79125 L13.88625,3.79125 L13.88625,2.985 L11.8575,2.985 L11.8575,1.38 L14.26125,1.38 L14.26125,0.5775 L10.84125,0.5775 L10.84125,6 L11.8575,6 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.e017deffa8f56d0b113cda2ed4602a1c.svg";
export { ForwardRef as ReactComponent };